import { convertToDateField } from 'platform/forms-system/src/js/validation';
import { isValidDateRange } from 'platform/forms-system/src/js/utilities/validations';

export const validateDateRange = (
  errors,
  dateRange,
  formData,
  schema,
  errorMessages,
  allowSameMonth = false, // This is actually only allowing the same date
) => {
  const fromDate = convertToDateField(dateRange.from);
  const toDate = convertToDateField(dateRange.to);

  if (!isValidDateRange(fromDate, toDate, allowSameMonth)) {
    errors.to.addError(
      errorMessages?.pattern || 'End date must be after start date',
    );
  }
};
